import { Plus, ChartPie } from "lucide-react";

interface ActionsProps {
  onOpenList: () => void;
  onInfo?: () => void;
  isListOpen?: boolean;
  isInfoOpen?: boolean;
}

export function Actions({ onOpenList, onInfo, isListOpen = false, isInfoOpen = false }: ActionsProps) {
  return (
    <div className="shrink-0 flex items-center gap-2">
      <button
        type="button"
        onClick={onOpenList}
        className={`h-9 flex items-center gap-1.5 px-3 rounded-full transition-all duration-150 ${
          isListOpen ? "bg-secondary border border-secondary text-main" : "border border-secondary text-secondary hover:bg-secondary/5"
        }`}
      >
        <Plus size={18} />
    
      </button>
      <button
        type="button"
        onClick={onInfo}
        className={`w-9 h-9 flex items-center justify-center rounded-full border transition-all duration-150 ${
          isInfoOpen ? "bg-secondary border-secondary text-main" : "border-secondary text-secondary hover:bg-secondary/5"
        }`}
      >
        <ChartPie size={22} />
      </button>
    </div>
  );
}
